<script lang="ts">
  import type { Snippet } from "svelte"

  import AutoRefreshOnFocus from "@/components/auto-refresh-on-focus.svelte"
  import PullToRefresh from "@/components/pull-to-refresh.svelte"
  import { Toaster } from "@/components/ui/sonner"
  import { useFlashSvelte } from "@/runes/use-flash.svelte"

  interface Props {
    children: Snippet
  }

  let { children }: Props = $props()

  useFlashSvelte()
</script>

<AutoRefreshOnFocus />
<PullToRefresh />
{@render children()}
<Toaster richColors />
